import { render, staticRenderFns } from "./Hero.vue?vue&type=template&id=07a67487&scoped=true&"
import script from "./Hero.vue?vue&type=script&lang=ts&"
export * from "./Hero.vue?vue&type=script&lang=ts&"
import style0 from "./Hero.vue?vue&type=style&index=0&id=07a67487&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07a67487",
  null
  
)

export default component.exports